import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { UserService } from "../../../services/user.service";
import { ProjectService } from "src/app/services/project.service";
import { ProjectResponse } from "src/app/models/projects/projectResponse";
import { NgxSpinnerService } from "ngx-spinner";
import { SweetAlertService } from "src/app/services/sweet-alert.service";
import { SweetAlertResult } from "sweetalert2";

@Component({
    selector: "app-project",
    templateUrl: "./project.component.html",
    styleUrls: ['./project.component.css']
})
export class ProjectComponent implements OnInit {
    projects: ProjectResponse[] = [];
    currentPage: number = 1;
    totalItems: number = 25;
    disabled: boolean = false;
    sortColumn: string = 'ProjectName';
    sortDirection: 'asc' | 'desc' = 'asc';

    configTableMaxRow: number = 10;
    configDropupAsRow: number = 8;
    constructor(
        private fb: FormBuilder,
        private userService: UserService,
        private projectService: ProjectService,
        private spinner: NgxSpinnerService,
        private sweetAlertService: SweetAlertService
      ) {

      }

    ngOnInit(): void {
        this.loadProjects();
    }

    pageChanged(event: any): void {
        console.log('Page changed to: ' + event.page);
        this.loadProjects(event.page);
    }

    sort(column: string) {
        console.log('sorted');
        this.sortColumn = column;
        this.currentPage = 1;
        this.loadProjects(this.currentPage);
    }

    loadProjects(page: number = 1) {
        this.spinner.show();
        this.projectService.getProjectList(page, this.configTableMaxRow, this.sortColumn).subscribe(
            data => {
                console.log('data', data);
                this.spinner.hide();

                this.projects = data.item?.items ?? [];
                this.totalItems = data.item?.total ?? 0;
                this.currentPage = page;
            },
            error => {
                this.spinner.hide();
                console.error('Error fetching projects:', error);
            }
        );
    }

    displayStatusIcon(proj: ProjectResponse): string {
        if (proj.projectStatus?.toLocaleLowerCase() == "active") {
            return "bg-success";
        }
        else {
            return "bg-warning";
        }
    }

    confirmRejectProject(project: any) {
        this.sweetAlertService.confirmWarning(
            'Confirmation',
            'Please confirm to reject ' + project.projectName + ' ?',
            'Confirm',
            'Cancel'
        ).then((result: SweetAlertResult) => {
            if (result.value) {
                this.sweetAlertService.success(
                  'Deleted!',
                  'Your request had been submited.'
                );
              }
        });
    }
}
